/* eslint-disable compat/compat */
/* eslint-disable node/no-unsupported-features/node-builtins */
import { useLocation } from "react-router-dom";

export default function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}
